import { render } from "./EnglishClassesForPrimary.vue?vue&type=template&id=132f01f0&scoped=true"
import script from "./EnglishClassesForPrimary.vue?vue&type=script&lang=js"
export * from "./EnglishClassesForPrimary.vue?vue&type=script&lang=js"

import "./EnglishClassesForPrimary.vue?vue&type=style&index=0&id=132f01f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132f01f0"]])

export default __exports__